import CallToActionBlock from "@components/CallToActionBlock/CallToActionBlock";

export default CallToActionBlock;
